import * as actionTypes from "../actions/actionTypes";
import axios from "../../utility/axios/axios";
import { errorsNotification, successNotification } from "./notification";

export const setWidgetInfo = (payload) => {
  return {
    type: actionTypes.SET_WIDGET_INFO,
    payload,
  };
};

export const setSteps = (payload) => {
  return {
    type: actionTypes.SET_STEPS,
    payload,
  };
};

export const setPlace = (payload) => {
  return {
    type: actionTypes.SET_PLACE,
    payload,
  };
};

export const setManyPlaces = (payload) => {
  return {
    type: actionTypes.SET_MANY_PLACES,
    payload,
  };
};

export const getWidgetInfo = (token) => {
  return (dispatch) => {
    axios
      .get(`/api/b2b/places/widget/${token}`)
      .then((response) => {
        if (response.status === 206) {
          dispatch(setWidgetInfo(response.data.data[0]));
          dispatch(setManyPlaces(response.data.data));
          dispatch(setSteps(5));
        } else {
          dispatch(setWidgetInfo(response.data.data));
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
};

export const getPlace = (id, callback) => {
  return (dispatch) => {
    axios
      .get(`/api/places/${id}`)
      .then((response) => {
        dispatch(setPlace(response.data.data));
        callback();
        document.querySelector(".BookingHeader").className = "BookingHeader";
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
};

export const setFreeSlots = (payload) => {
  return {
    type: actionTypes.SET_FREE_SLOTS,
    payload,
  };
};

export const getFreeSlots = (service_id, calendar_id) => {
  return (dispatch) => {
    axios
      .post(
        "/api/free-slots",
        calendar_id ? { service_id, calendar_id } : { service_id }
      )
      .then((response) => {
        dispatch(setFreeSlots(response.data.data));
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
};

export const createAppointment = (
  date,
  from,
  service_id,
  calendar_id,
  bookingNotes,
  required_info,
  callback
) => {
  return (dispatch) => {
    axios
      .post(
        "/api/create-appointment",
        calendar_id
          ? {
              date,
              from,
              service_id,
              calendar_id,
              required_info,
              notes: bookingNotes,
            }
          : {
              date,
              from,
              service_id,
              required_info,
              notes: bookingNotes,
            }
      )
      .then((response) => {
        dispatch(successNotification(response.data.message));
        callback();
      })
      .catch((error) => {
        if (error.response.status === 422) {
          Object.keys(error.response.data.errors).map((errorData) =>
            error.response.data.errors[errorData].map((message) =>
              dispatch(errorsNotification(message))
            )
          );
        } else dispatch(errorsNotification(error.response.data.message));
      });
  };
};
